import React from 'react';
import { Link } from 'react-router-dom';
import './whychooseus.css';

const WhyChooseUs: React.FC = () => {
  return (
    <section className="why-choose-section" aria-labelledby="why-choose-heading">
      <div className="why-choose-container">
        
        {/* Left Side: Content */}
        <div className="why-choose-left">
          <div className="why-choose-eyebrow">
            <span className="wce-dash"></span>
            WHY E-COMMERCE BRANDS CHOOSE
          </div>
          
          <h2 id="why-choose-heading" className="why-choose-title">
            <span className="text-dark">Pick Pack Pro for</span><br />
            <span className="text-blue">UK Fulfilment</span>
          </h2>
          
          <p className="why-choose-desc">
            A fulfilment partner built for UK eCommerce brands — combining reliable infrastructure, proven processes and scalable solutions to help you grow, without the operational headaches.
          </p>
          
          <div className="why-choose-grid">
            <div className="wc-feature">
              <div className="wc-icon-wrapper bg-blue-light">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1A44E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><polyline points="9 12 11 14 15 10"></polyline></svg>
              </div>
              <div className="wc-text">
                <h3>Secure Infrastructure</h3>
                <p>Modern UK facilities with 24/7 security, stock control and full inventory visibility.</p>
              </div>
            </div>
            
            <div className="wc-feature">
              <div className="wc-icon-wrapper bg-orange-light">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#F68C43" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle><line x1="22" y1="12" x2="18" y2="12"></line><line x1="6" y1="12" x2="2" y2="12"></line><line x1="12" y1="6" x2="12" y2="2"></line><line x1="12" y1="22" x2="12" y2="18"></line></svg>
              </div>
              <div className="wc-text">
                <h3>Precision Execution</h3>
                <p>Accurate receiving, picking, packing and dispatch with strict quality control.</p>
              </div>
            </div>
            
            <div className="wc-feature">
              <div className="wc-icon-wrapper bg-orange-light">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#F68C43" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line></svg>
              </div>
              <div className="wc-text">
                <h3>Scalable Fulfilment Systems</h3>
                <p>Technology-driven operations built to handle seasonal peaks and high-volume growth.</p>
              </div>
            </div>
            
            <div className="wc-feature">
              <div className="wc-icon-wrapper bg-blue-light">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#1A44E5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
              </div>
              <div className="wc-text">
                <h3>Structured Reverse Logistics</h3>
                <p>Efficient returns management to keep your customers happy and your operations running smoothly.</p>
              </div>
            </div>
          </div>
          
          <div className="why-choose-cta">
            <Link to="/contact-fulfillment-services" className="wc-btn">
              Get a Fulfilment Quote 
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
            </Link>
            
            <div className="wc-trust-badges">
              <div className="wc-badge">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
                Fast onboarding
              </div>
              <div className="wc-badge">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z"></path><path d="M21 16v2a4 4 0 0 1-4 4h-5"></path></svg>
                Dedicated UK support
              </div>
              <div className="wc-badge">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                No long-term contracts
              </div>
            </div>
          </div>
          
        </div>

        {/* Right Side: Map Image */}
        <div className="why-choose-right">
          <img 
            src="/homepageimages/uk-map-3d.jpg" 
            alt="UK Fulfilment Map Network" 
            className="wc-map-image"
            loading="lazy"
          />
        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;

